var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_c('ul',_vm._l((_vm.breadcrumbList),function(breadcrumb,idx){return _c('li',{key:idx,class:{'linked': breadcrumb.link},on:{"click":function($event){return _vm.routeTo(breadcrumb)}}},[_vm._v(" "+_vm._s(_vm.$t(breadcrumb.name_i18n))+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }